
<mat-form-field class="example-chip-list" appearance="outline" style="width:100%;">
    <mat-label>Adresy mailowe</mat-label>
    <mat-chip-grid #chipGrid aria-label="Enter adresses">
      @for (email of emails(); track email) {
        <mat-chip-row
          (removed)="remove(email)"
          [editable]="true"
          (edited)="edit(email, $event)"
          [aria-description]="'press enter to edit ' + email"
        >
          {{email}}
          <button matChipRemove [attr.aria-label]="'remove ' + email">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip-row>
      }
      <input
        placeholder="New email..."
        [matChipInputFor]="chipGrid"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="addOnBlur"
        (matChipInputTokenEnd)="add($event)"
        type="email"
      />
    </mat-chip-grid>
  </mat-form-field>